import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initializeErrorTracking } from "@/utils/errorTracking";

// Initialize global error tracking (Crashlytics-like for web)
initializeErrorTracking();

const rootElement = document.getElementById("root");

// Check if the app is being hydrated (pre-rendered by react-snap)
if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered content
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Standard client-side render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
